import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import {
    FaArrowUp, FaList, FaFileInvoiceDollar, FaFileAlt, FaSearch,
    FaChevronDown, FaChevronUp, FaCalendarAlt, FaUser, FaRegCreditCard,
    FaRegArrowAltCircleUp, FaRegArrowAltCircleDown, FaExchangeAlt
} from 'react-icons/fa';
import api from '../../services/api';
import Data from '../../components/Data';
import ReactSelect from '../../components/ReactSelect';
import moment from 'moment';
import CalendarioEventos from '../../components/CalendarioEventos';
import { OrigemMoeda } from '../../components/ValorComOrigem';
import { somarOrigens } from '../../components/moedaOrigemPolicy';
import { periodoPainel, momentPainel } from './painelFinanceiroPeriodo';
import '../../css/financeiro-redesign.css';
import '../../css/financeiro-parcela-pagar.css';

// Grupos de perfis que enxergam cada aba (mantido idêntico ao comportamento anterior)
const PERFIS_FINANCEIRO = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'];
const PERFIS_COMPRA = [...PERFIS_FINANCEIRO, 'gerenteevento', 'gerenteeventointernacional', 'evento'];
const PERFIS_CADASTRO = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'];

export default function PainelFinanceiro() {
    const history = useHistory();
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [caixas, setCaixas] = useState([]);
    const [saldos, setSaldos] = useState({});
    const [filtro, setFiltro] = useState({});
    const [expandedClients, setExpandedClients] = useState(() => new Set());
    const [financialData, setFinancialData] = useState({ clients: [] });
    const [loadingFinancial, setLoadingFinancial] = useState(false);
    const [calendarioAberto, setCalendarioAberto] = useState(false);
    const [totalAdiantamentos, setTotalAdiantamentos] = useState(0);
    const [solicitadoAdiantamentos, setSolicitadoAdiantamentos] = useState(0); // a aprovar (não creditado)
    const [creditadoAdiantamentos, setCreditadoAdiantamentos] = useState(0);   // já caiu (creditado)

    const tabs = [
        { to: '/financeiroParcelaPagar', label: 'Contas a Pagar', icon: <FaRegArrowAltCircleUp size={16} color="#c1232b" />, roles: PERFIS_FINANCEIRO },
        { to: '/financeiroParcelaReceber', label: 'Contas a Receber', icon: <FaRegArrowAltCircleDown size={16} color="#15803d" />, roles: PERFIS_FINANCEIRO },
        // D-0056: a fila do Faturamento só abria pelo botão do Contas a Receber.
        { to: '/financeiroFaturamento', label: 'Faturamento', icon: <FaFileInvoiceDollar size={15} />, roles: PERFIS_FINANCEIRO },
        { to: '/financeiroSaldoAdiantamento', label: 'Adiantamentos / Saldos', icon: <FaExchangeAlt size={15} />, roles: PERFIS_FINANCEIRO },
        { to: '/venda', label: 'Faturas Clientes', icon: <FaFileInvoiceDollar size={15} />, roles: PERFIS_FINANCEIRO },
        { to: '/compra', label: 'Faturas Fornecedores', icon: <FaFileInvoiceDollar size={15} />, roles: PERFIS_COMPRA },
        { to: '/produto', label: 'Lista de Serviços', icon: <FaList size={15} />, roles: PERFIS_CADASTRO },
        { to: '/financeiroCaixa', label: 'Caixas', icon: <FaList size={15} />, roles: PERFIS_CADASTRO },
        { to: '/financeiroPlanoConta', label: 'Plano de Contas', icon: <FaList size={15} />, roles: PERFIS_CADASTRO },
        { to: '/financeiroRelatorioDre', label: 'DRE', icon: <FaFileAlt size={15} />, roles: PERFIS_FINANCEIRO },
    ].filter(t => t.roles.includes(perfil));

    const formatCurrency = (value) => {
        return parseFloat(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const formatDate = (dateStr) => {
        return moment(dateStr).format('DD/MM/YYYY');
    };

    const formatCnpj = (cnpj) => {
        if (!cnpj) return '';
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    };

    const toggleClient = (clientId) => {
        setExpandedClients(prev => {
            const next = new Set(prev);
            if (next.has(clientId)) {
                next.delete(clientId);
            } else {
                next.add(clientId);
            }
            return next;
        });
    };

    const expandirTudo = () => {
        setExpandedClients(new Set((financialData.clients || []).map(c => c.id)));
    };

    const recolherTudo = () => {
        setExpandedClients(new Set());
    };

    const handleEventClick = (eventId, eventName, e) => {
        e.stopPropagation(); // Previne que o card expanda/colapse

        // Reunião 17/06/2026: clicar no evento leva direto às Contas Pendentes
        // daquele evento (não mais para a página de eventos).
        const nomeParam = eventName ? `&nomeEvento=${encodeURIComponent(eventName)}` : '';
        history.push(`/financeiroParcelaPagar?idEvento=${eventId}${nomeParam}`);
    };

    // Raio-X financeiro (treinamento 07/10, item 14): leva o período ativo junto.
    const urlRaioX = (clienteId, eventoId) => {
        const q = new URLSearchParams();
        if (clienteId) q.set('cliente', clienteId);
        if (eventoId) q.set('evento', eventoId);
        if (periodo.params.dataInicio) q.set('dataInicio', periodo.params.dataInicio);
        if (periodo.params.dataFim) q.set('dataFim', periodo.params.dataFim);
        const qs = q.toString();
        return '/financeiroRaioX' + (qs ? '?' + qs : '');
    };
    const abrirRaioX = (clienteId, eventoId, e) => {
        if (e) e.stopPropagation(); // não expande/colapsa o cliente
        history.push(urlRaioX(clienteId, eventoId));
    };

    const buscarCaixas = () => {
        api({
            method: 'get',
            action: '/financeiroCaixa',
            token: token,
            params: {}
        })
            .then(response => {
                const lista = response.data.data || [];
                setCaixas(lista);
            })
            .catch(() => { });
    };

    const buscarSaldos = () => {
        api({
            method: 'get',
            action: '/financeiroMovimentoCaixa/saldos',
            token: token,
            params: {}
        })
            .then(response => {
                setSaldos(response.data.data || {});
            })
            .catch(() => { });
    }

    // C05: período em aaaa-mm-dd (o componente Data devolve dd/mm/aaaa) e validado antes de buscar.
    const periodo = periodoPainel(filtro);

    const buscarTotalAdiantamentos = () => {
        if (periodo.erro) return;
        const params = { ...periodo.params };

        api({
            method: 'get',
            action: '/financeiroTitulo/totalAdiantamentos',
            token: token,
            params: params
        })
            .then(response => {
                const data = response.data.data || {};
                setTotalAdiantamentos(data.total || 0);
                setSolicitadoAdiantamentos(data.solicitado || 0);
                setCreditadoAdiantamentos(data.creditado || 0);
            })
            .catch(() => {
                setTotalAdiantamentos(0);
                setSolicitadoAdiantamentos(0);
                setCreditadoAdiantamentos(0);
            });
    }

    const buscarDadosFinanceiros = () => {
        if (periodo.erro) return;
        setLoadingFinancial(true);
        const params = { ...periodo.params };

        if (filtro.tipo) {
            params.tipo = filtro.tipo;
        }

        api({
            method: 'get',
            action: '/evento/dadosFinanceirosPorCliente',
            token: token,
            params: params
        })
            .then(response => {
                const data = response.data.data || {};
                setFinancialData(data);
            })
            .catch(() => {
                setFinancialData({ clients: [] });
            })
            .finally(() => {
                setLoadingFinancial(false);
            });

        // Busca total de adiantamentos
        buscarTotalAdiantamentos();
    }

    useEffect(() => {
        buscarCaixas();
        buscarSaldos();
        buscarDadosFinanceiros();
        buscarTotalAdiantamentos();
        // eslint-disable-next-line
    }, []);

    const handleBuscar = (e) => {
        e.preventDefault();
        buscarDadosFinanceiros();
    };

    const handleLimpar = () => {
        setFiltro({});
    };

    // Calcula totais dos dados financeiros
    const calcularTotais = () => {
        if (!financialData.clients || financialData.clients.length === 0) {
            return {
                totalAmount: 0,
                totalAgencyPayment: 0,
                totalClientPayment: 0,
                totalFees: 0,
                totalEvents: 0,
                totalClients: 0
            };
        }

        const totais = financialData.clients.reduce((acc, client) => {
            acc.totalAmount += parseFloat(client.amount) || 0;
            acc.totalAgencyPayment += parseFloat(client.agencyPayment) || 0;
            acc.totalClientPayment += parseFloat(client.clientPayment) || 0;
            acc.totalFees += parseFloat(client.fees) || 0;
            acc.totalEvents += parseInt(client.events) || 0;
            return acc;
        }, {
            totalAmount: 0,
            totalAgencyPayment: 0,
            totalClientPayment: 0,
            totalFees: 0,
            totalEvents: 0,
            totalClients: 0
        });

        // Adiciona a quantidade de clientes
        totais.totalClients = financialData.clients.length;

        return totais;
    };

    const totais = calcularTotais();
    const ticketMedio = totais.totalEvents > 0 ? totais.totalAmount / totais.totalEvents : 0;
    // Item 15: parte estrangeira dos totais (já convertida em R$ pela API), por moeda.
    const origemTotal = somarOrigens((financialData.clients || []).map((c) => c.origem_moeda));
    const hasClients = financialData.clients && financialData.clients.length > 0;

    const opcoesTipo = [
        { value: 'advisoryboard', label: 'Advisory Board' },
        { value: 'congresso', label: 'Congresso' },
        { value: 'convencaonacional', label: 'Convenção' },
        { value: 'estandecotapat', label: 'Estande e/ou Cota de Patrocínio' },
        { value: 'eventoexclusivo', label: 'Evento Exclusivo' },
        { value: 'eventointerno', label: 'Evento Interno' },
        { value: 'eventoterceiros', label: 'Evento de Terceiros' },
        { value: 'minimeet', label: 'Mini Meeting' },
        { value: 'orgsede', label: 'Organizado Pela Sede' },
        { value: 'simposio', label: 'Simpósio' },
    ];

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-rd">

                {/* Abas (navegação financeira) */}
                {/* Cabeçalho */}
                <div className="fin-rd__head">
                    <div>
                        <h1 className="fin-rd__title">Financeiro</h1>
                        <p className="fin-rd__subtitle">Calendário de eventos · resumo por cliente</p>
                    </div>
                </div>

                <ul className="fin-rd__tabs">
                    {tabs.map(tab => (
                        <li key={tab.to} style={{ listStyle: 'none' }}>
                            <Link to={tab.to} className="fin-rd__tab">
                                {tab.icon}{tab.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* Entrada do Raio-X financeiro do evento */}
                <div className="fin-pp">
                    <div className="fin-pp__banner is-info" style={{ alignItems: 'center' }}>
                        <FaSearch className="fin-pp__banner-ic" size={15} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <strong>Raio-X financeiro do evento</strong> — veja a saúde financeira por cliente ou evento:
                            orçado, pago, a pagar, notas fiscais, ND × NF, adiantamento e saldo.
                        </div>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => abrirRaioX(null, null)}>
                            Abrir Raio-X
                        </button>
                    </div>
                </div>

                {/* Cards de saldos */}
                <section className="fin-rd__banks">
                    {caixas.map((cx) => {
                        const saldo = parseFloat(saldos[cx.id] || 0);
                        return (
                            <div key={cx.id} className="fin-rd__bank">
                                <div className="fin-rd__bank-head">
                                    <span className={`fin-rd__bank-icon${saldo < 0 ? ' is-negative' : ''}`}><FaRegCreditCard size={15} /></span>
                                    <span className="fin-rd__bank-name">{cx.nome}</span>
                                </div>
                                <div className={`fin-rd__bank-value${saldo < 0 ? ' is-negative' : ''}`}>
                                    {formatCurrency(saldo)}
                                </div>
                                <div className="fin-rd__bank-sub">Saldo atual</div>
                            </div>
                        );
                    })}
                    <div className="fin-rd__bank">
                        <div className="fin-rd__bank-head">
                            <span className="fin-rd__bank-icon is-accent"><FaArrowUp size={15} /></span>
                            <span className="fin-rd__bank-name">Adiantamentos</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, margin: '2px 0 6px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
                                <span style={{ fontSize: 11.5, color: '#586478' }}>Solicitado (a aprovar)</span>
                                <span className="is-accent" style={{ fontWeight: 700 }}>{formatCurrency(solicitadoAdiantamentos)}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
                                <span style={{ fontSize: 11.5, color: '#586478' }}>Já caiu (creditado)</span>
                                <span style={{ fontWeight: 700, color: '#15803d' }}>{formatCurrency(creditadoAdiantamentos)}</span>
                            </div>
                        </div>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" style={{ width: '100%' }}
                            onClick={() => history.push('/financeiroSaldoAdiantamento')}>
                            <FaExchangeAlt size={11} style={{ marginRight: 4 }} /> Saldos / Remanejar
                        </button>
                    </div>
                    {caixas.length === 0 ? (
                        <div className="fin-rd__banks-empty">Nenhum caixa cadastrado</div>
                    ) : null}
                </section>


                {/* Barra de filtros */}
                <form className="fin-rd__card fin-rd__filters" onSubmit={handleBuscar}>
                    <label className="fin-rd__field">
                        <span className="fin-rd__label">Tipo</span>
                        <ReactSelect
                            value={filtro.tipo ? { value: filtro.tipo, label: filtro.nomeTipo } : null}
                            onChange={e => setFiltro({ ...filtro, tipo: e?.value, nomeTipo: e?.label })}
                            options={opcoesTipo}
                            placeholder="Todos os tipos"
                        />
                    </label>
                    <div className="fin-rd__field fin-rd__field--sm">
                        <span className="fin-rd__label">Data início</span>
                        <Data
                            value={filtro.dataInicio}
                            onChange={date => setFiltro({ ...filtro, dataInicio: date })}
                            parse={momentPainel}
                        />
                    </div>
                    <div className="fin-rd__field fin-rd__field--sm">
                        <span className="fin-rd__label">Data fim</span>
                        <Data
                            value={filtro.dataFim}
                            onChange={date => setFiltro({ ...filtro, dataFim: date })}
                            parse={momentPainel}
                        />
                    </div>
                    {periodo.erro && (
                        <div role="alert" style={{ flexBasis: '100%', order: -1, fontSize: 12.5, fontWeight: 600, color: '#b45309' }}>
                            {periodo.erro}
                        </div>
                    )}
                    <button type="submit" className="fin-rd__btn" disabled={!!periodo.erro}
                        style={periodo.erro ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                        title={periodo.erro || 'Mostra os eventos cujo período cruza as datas do filtro'}>
                        <FaSearch size={15} /> Buscar
                    </button>
                    <button type="button" className="fin-rd__btn fin-rd__btn--ghost" onClick={handleLimpar}>
                        Limpar
                    </button>
                </form>

                {/* Faixa de estatísticas */}
                {hasClients && (
                    <section className="fin-rd__card fin-rd__stats">
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Clientes</div>
                            <div className="fin-rd__stat-value">{totais.totalClients}</div>
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Eventos</div>
                            <div className="fin-rd__stat-value">{totais.totalEvents}</div>
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Total</div>
                            <div className="fin-rd__stat-value">{formatCurrency(totais.totalAmount)}</div>
                            <OrigemMoeda origem={origemTotal} />
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Agência</div>
                            <div className="fin-rd__stat-value is-warn">{formatCurrency(totais.totalAgencyPayment)}</div>
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Cliente Direto</div>
                            <div className="fin-rd__stat-value is-ok">{formatCurrency(totais.totalClientPayment)}</div>
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">FEEs</div>
                            <div className="fin-rd__stat-value is-info">{formatCurrency(totais.totalFees)}</div>
                        </div>
                        <div className="fin-rd__stat">
                            <div className="fin-rd__stat-label">Ticket Médio</div>
                            <div className="fin-rd__stat-value is-muted">{formatCurrency(ticketMedio)}</div>
                        </div>
                    </section>
                )}

                {/* Calendário de Eventos (accordion) */}
                <section className="fin-rd__section">
                    <div className="fin-rd__card">
                        <div
                            className="fin-rd__accordion-head"
                            onClick={() => setCalendarioAberto(!calendarioAberto)}
                        >
                            <span className="fin-rd__accordion-title">
                                <FaCalendarAlt /> Calendário de Eventos
                            </span>
                            {calendarioAberto ? <FaChevronUp color="#94a3b8" /> : <FaChevronDown color="#94a3b8" />}
                        </div>
                        {calendarioAberto && (
                            <div className="fin-rd__accordion-body">
                                <CalendarioEventos />
                            </div>
                        )}
                    </div>
                </section>

                {/* Lista de clientes / eventos */}
                <section className="fin-rd__section">
                    <div className="fin-rd__section-head">
                        <span className="fin-rd__section-icon"><FaCalendarAlt size={18} /></span>
                        <div>
                            <h2 className="fin-rd__section-title">Resumo por Cliente</h2>
                            <p className="fin-rd__section-sub">
                                {totais.totalClients} clientes · {totais.totalEvents} eventos no período
                            </p>
                        </div>
                        {hasClients && (
                            <div className="fin-rd__section-actions">
                                <button type="button" className="fin-rd__btn fin-rd__btn--sm" onClick={recolherTudo}>
                                    Recolher tudo
                                </button>
                                <button type="button" className="fin-rd__btn fin-rd__btn--sm" onClick={expandirTudo}>
                                    Expandir tudo
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="fin-rd__card fin-rd__table">
                        <div className="fin-rd__table-scroll">
                            <div className="fin-rd__row fin-rd__thead">
                                <span></span>
                                <span className="fin-rd__th">Cliente / Evento</span>
                                <span className="fin-rd__th fin-rd__th--right">Agência</span>
                                <span className="fin-rd__th fin-rd__th--right">Cliente Direto</span>
                                <span className="fin-rd__th fin-rd__th--right">FEE</span>
                                <span className="fin-rd__th fin-rd__th--right">Total · %</span>
                            </div>

                            {loadingFinancial ? (
                                <div className="fin-rd__empty">Carregando dados financeiros...</div>
                            ) : hasClients ? (
                                financialData.clients.map((client) => {
                                    const isOpen = expandedClients.has(client.id);
                                    const amount = parseFloat(client.amount) || 0;
                                    const pct = totais.totalAmount > 0 ? (amount / totais.totalAmount) * 100 : 0;
                                    const pctFmt = pct % 1 === 0 ? pct.toFixed(0) : pct.toFixed(1).replace('.', ',');
                                    const barWidth = amount > 0 ? Math.max(pct, 2) : 0;
                                    return (
                                        <div key={client.id} className="fin-rd__client">
                                            <div className="fin-rd__row fin-rd__client-row" onClick={() => toggleClient(client.id)}>
                                                <span className="fin-rd__caret">
                                                    {isOpen ? <FaChevronUp size={13} /> : <FaChevronDown size={13} />}
                                                </span>
                                                <div className="fin-rd__client-id">
                                                    {client.codigo ? <span className="fin-rd__code">{client.codigo}</span> : null}
                                                    <div style={{ minWidth: 0 }}>
                                                        <div className="fin-rd__client-name">{client.name}</div>
                                                        {client.cnpj ? <div className="fin-rd__client-cnpj">{formatCnpj(client.cnpj)}</div> : null}
                                                    </div>
                                                    <span className="fin-rd__chip">{client.events} eventos</span>
                                                    <button type="button" className="fin-rd__btn fin-rd__btn--sm" title="Raio-X financeiro do cliente"
                                                        onClick={(e) => abrirRaioX(client.id, null, e)}>
                                                        <FaSearch size={10} style={{ marginRight: 4 }} />Raio-X
                                                    </button>
                                                </div>
                                                <span className={`fin-rd__num ${!parseFloat(client.agencyPayment) ? 'is-zero' : 'is-warn'}`}>
                                                    {formatCurrency(client.agencyPayment)}
                                                </span>
                                                <span className={`fin-rd__num ${!parseFloat(client.clientPayment) ? 'is-zero' : 'is-ok'}`}>
                                                    {formatCurrency(client.clientPayment)}
                                                </span>
                                                <span className={`fin-rd__num ${!parseFloat(client.fees) ? 'is-zero' : 'is-info'}`}>
                                                    {formatCurrency(client.fees)}
                                                </span>
                                                <div className="fin-rd__total">
                                                    <div className={`fin-rd__total-value${amount === 0 ? ' is-zero' : ''}`}>
                                                        {formatCurrency(amount)}
                                                    </div>
                                                    <OrigemMoeda origem={client.origem_moeda} />
                                                    <div className="fin-rd__pct">
                                                        <span className="fin-rd__pct-bar"><span style={{ width: `${barWidth}%` }}></span></span>
                                                        <span className="fin-rd__pct-label">{pctFmt}%</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {isOpen && (
                                                <div className="fin-rd__subwrap">
                                                    {(client.events_list || []).map((event, idx) => {
                                                        const isCongresso = /congresso/i.test(event.type || '');
                                                        return (
                                                            <div key={idx} className="fin-rd__row fin-rd__event-row">
                                                                <span></span>
                                                                <div className="fin-rd__event-main">
                                                                    <div className="fin-rd__event-title-line">
                                                                        <span
                                                                            className="fin-rd__event-name"
                                                                            onClick={(e) => handleEventClick(event.id, event.name, e)}
                                                                        >
                                                                            {event.name}
                                                                        </span>
                                                                        <button type="button" className="fin-rd__btn fin-rd__btn--sm" title="Raio-X financeiro do evento"
                                                                            onClick={(e) => abrirRaioX(client.id, event.id, e)}>
                                                                            <FaSearch size={10} style={{ marginRight: 4 }} />Raio-X
                                                                        </button>
                                                                        {event.type ? (
                                                                            <span className={`fin-rd__tag${isCongresso ? ' is-accent' : ''}`}>
                                                                                {event.type}
                                                                            </span>
                                                                        ) : null}
                                                                    </div>
                                                                    <div className="fin-rd__event-meta">
                                                                        <span><FaCalendarAlt size={11} />{formatDate(event.startDate)} – {formatDate(event.endDate)}</span>
                                                                        {event.responsible ? <span><FaUser size={11} />{event.responsible}</span> : null}
                                                                        {event.location ? <span>{event.location}</span> : null}
                                                                    </div>
                                                                </div>
                                                                <span className="fin-rd__event-num">{formatCurrency(event.agencyPayment)}</span>
                                                                <span className="fin-rd__event-num">{formatCurrency(event.clientPayment)}</span>
                                                                <span className="fin-rd__event-num">{formatCurrency(event.fee)}</span>
                                                                <span className="fin-rd__event-total">{formatCurrency(event.amount)}<OrigemMoeda origem={event.origem_moeda} /></span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="fin-rd__empty">Nenhum dado encontrado. Use os filtros acima para buscar.</div>
                            )}
                        </div>
                    </div>
                </section>

            </div>
        </ErpTemplate>
    );
}
